<script lang="ts">
    import { onMount } from 'svelte'
    import { GridButton, GridClass, GridCol, GridColTypeEnum, GridLine } from '../../_common/z/zgrid'
    import Grid from '../../_common/z/zgrid.svelte'
    import dayjs from 'dayjs'
    import 'dayjs/locale/pt-br'
    import type { BalanceResult } from '../../../modules/posApi/balance-results/balance-result'
    import { faPerson, faUser } from '@fortawesome/free-solid-svg-icons'
    import LoadSpinner from '../../_common/load-spinner.svelte'
    dayjs.locale('pt-br')

    let show = false

    let grid: GridClass = null
    async function load() {
        if (show) return
        show = true
        let data: BalanceResult[] = await window.api.pos.balanceResults.getAll()
        data = await window.api.utils.utils.assignPersonsFromObject(data)
        data = await window.api.utils.utils.assignServicesFromObject(data)
        console.log('data-in', data)
        //
        grid = new GridClass()
        grid.title = 'Pessoas com saldo INCONSISTENTE de serviços'
        grid.subtitle = 'Utilize este relatório para identificar e corrigir clientes com saldo inconsistente'
        grid.cols.push(new GridCol({ content: 'Nome' }))
        grid.cols.push(new GridCol({ content: 'Telefone', type: GridColTypeEnum.phone }))
        grid.cols.push(new GridCol({ content: 'Serviço' }))
        grid.cols.push(new GridCol({ content: 'Comprado', type: GridColTypeEnum.float }))
        grid.cols.push(new GridCol({ content: 'Ajustes', type: GridColTypeEnum.float }))
        grid.cols.push(new GridCol({ content: 'Consumido', type: GridColTypeEnum.float }))
        grid.cols.push(new GridCol({ content: 'Agendado', type: GridColTypeEnum.float }))
        grid.cols.push(new GridCol({ content: 'A agendar', type: GridColTypeEnum.float }))
        grid.cols.push(new GridCol({ type: GridColTypeEnum.button }))
        for (const balance of data) {
            //if (balance.consumed === 0) continue // se não houve compra (ou o ajuste zerou a compra), então não acompanha o saldo
            if (balance.unscheduled < 0 || balance.purchased < balance.unscheduled + balance.scheduled + balance.consumed) {
                let btnPerson: GridButton = new GridButton({
                    callback: () => window.person('show', balance.personId),
                    icon: faUser,
                })
                let line: GridLine = new GridLine()
                line.slots.push({ content: balance.person?.name })
                line.slots.push({ content: balance.person?.phone })
                line.slots.push({ content: balance.service?.name || '-' })
                line.slots.push({ content: balance.purchased })
                line.slots.push({ content: balance.adjustments })
                line.slots.push({ content: balance.consumed })
                line.slots.push({ content: balance.scheduled })
                line.slots.push({ content: balance.unscheduled })
                line.slots.push({ content: [btnPerson] })
                grid.lines.push(line)
            }
        }
        console.log('grid', grid)
        grid = grid
        show = false
    }

    onMount(() => {
        load()
    })
</script>

<div class="relat-body">
    <div class="grid mt-2">
        <Grid {grid} />
    </div>
</div>
<LoadSpinner {show}></LoadSpinner>
